module.exports = __webpack_public_path__ + "img/muros_divisorios_y_estructurales_aparentes.e725e8d5.png";